// extracted by mini-css-extract-plugin
export default {"colPlots":"colPlots__yo6sz","colGenerateDate":"colGenerateDate__v9O2d","colSendDate":"colSendDate__ZVXgM","colActions":"colActions__TYHmy","actions":"actions__k0Zbs"};